/**
 * @desc 订单可退运费查询
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.asRefundOrderFacadeImpl.refundSpShipping.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/asRefundOrder/refundSpShipping`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
